<tr class="table-body-row table-body-row--expandable-table" *ngIf="expandableTable && expanded">
  <td [attr.colspan]="cells.length">
    <table class="table-body-row--expandable-table">
      <ng-content></ng-content>
    </table>
  </td>
</tr>

<tr class="table-body-row table-body-row--expandable-table" *ngIf="!expandableTable || !expanded">
  <ng-content></ng-content>
</tr>
